module.exports = __webpack_public_path__ + "img/logo-login-page.50e704e9.png";